import {vinRe} from '@deliveriesondemand/dod-regexes';
import {formatPercent} from '@deliveriesondemand/dod-utils';
import {ExtraData} from '@deliveriesondemand/dod-data';
import {formatMoney} from 'accounting';
import moment from 'moment';
import {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import Button from '-/components/general/Button';
import Form from '-/components/fields/Form';
import {center, rem, size} from '-/styles/utils';
import {getOfferId, getVinVehicleInfo} from '-/util/util';
import NavigationService from '-/services/NavigationService';
import SessionService from '-/services/SessionService';
import ToastService from '-/services/ToastService';
import {saveDoc} from '-/api/api';
import {duplicateOfferSetData} from '-/util/authenticate';
import {renderError} from '-/util/error';
import {get, set} from '-/util/lodash';
import Vin from '-/components/fields/vehicle/Vin';
import Trim from '-/components/fields/vehicle/Trim';
import VehicleInfoService from '-/services/VehicleInfoService';

const styles = theme => ({
    description: {
        paddingTop: rem(20),
        textAlign: 'center',
        '& p': {
            padding:10,
            paddingLeft: 20,
            paddingRight: 20
        },
        '& h4': {
            paddingLeft: rem(35)
        },
        '& ul': {
            paddingLeft: rem(55)
        }
    },
    left: {
        textAlign: 'left',
        marginTop: 20
    },
    icon: {
        display: 'table',
        position: 'relative',
        margin: '0 auto'
    },
    text: {
        margin: rem(20)
    },
    check: {
        ...size('50px'),
        backgroundColor: theme.colors.primary,
        right: rem(-24),
        position: 'absolute',
        bottom: rem(0),
        borderRadius: '50%',
        '&::before, &:before': {
            ...center('both'),
            content: '"\\f00c"',
            display: 'block',
            fontFamily: 'FontAwesome',
            fontSize: '150%',
            fontWeight: 'normal',
            lineHeight: rem(24),
            color: 'white'
        }
    },
    otherLoan: {
        border: '1px solid #000',
        width: '90%',
        padding: 10,
        margin: '20px auto'
    },
    topMargin: {
        marginTop: 20
    }
});

class Congrats extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addedAdditionalVehicle: false,
            submitted: false,
            vinTrims: []
        };

        this.handleSaveClick = this.handleSaveClick.bind(this);
    }

    componentDidMount() {
        const {fbq} = window;

        if (fbq) {
            fbq('track', 'SubmitApplication');
        }
    }

    async handleSaveClick() {
        const {stips, offerId, vehicleInfo = {}} = this.props;
        const vinStipType = 'VIN';
        const vinStip = stips.find(stip => stip.stipType === vinStipType);
        const {fields = {}, owner} = ExtraData[vinStipType];
        const vinExtraData = {};
        let doc;

        if (get(vinStip, 'docs.length', 0)) {
            [doc] = vinStip.docs;
        }

        const vinVehicleInfo = getVinVehicleInfo(vehicleInfo);

        if (vinVehicleInfo) {
            set(vehicleInfo, 'vinVehicleInfo', vinVehicleInfo);
        }

        Object.keys(fields).forEach(key => {
            const dataKey = owner ? `${owner}.${key}` : key;
            set(vinExtraData, dataKey, vehicleInfo[key]);
        });

        doc = {
            ...doc,
            extra: vinExtraData
        };

        try {
            await saveDoc({
                _id: offerId,
                stipType: vinStipType,
                applicantType: 'app',
                indexOfDoc: 0
            }, doc);

            this.setState({submitted: true});
        } catch(ex) {
            ToastService.addToastWithDuration(ToastService.DANGER, 5000, renderError(ex));
        }
    }

    handleAdditionalVehicleClick = async props => {
        this.setState({addedAdditionalVehicle: true});
        const {otherLoanId} = props;
        await duplicateOfferSetData({otherLoanId});
    };

    handleStipsClick = () => {
        const {origin, search} = get(window, 'location', {});
        const stipsUrl = `${origin}${search}&stips=app`;
        window.history.pushState({path: stipsUrl}, '', stipsUrl);
        NavigationService.next('stips');
    };

    onVehicleChange = (vehicleObj = {}) => {
        for (const [key, value] of Object.entries(vehicleObj)) {
            VehicleInfoService.set(key, value);
        }
    };

    onAccessoryChange = (info = []) => {
        VehicleInfoService.setAccessories(info);
    };

    onVinChange = data => {
        const {trims = [], vehicle = {}} = data;

        VehicleInfoService.setExperianData(data);
        this.onVehicleChange(vehicle);
        this.setState({vinTrims: trims});
    };

    render() {
        const {
            buyerName,
            isCU,
            isDealer,
            showVinReminder,
            contactPhone,
            otherLoans = [],
            ltvPass,
            classes = {},
            vehicleInfo = {}
        } = this.props;
        const {addedAdditionalVehicle, submitted, vinTrims} = this.state;
        const {style, vin} = vehicleInfo;
        const canSubmitVin = vin && vinRe.test(vin) && style;
        const hasOtherLoans = otherLoans.length > 0;
        let additionalVehiclesMsg = 'Are there any other vehicles you would like to refinance?';

        if (hasOtherLoans) {
            additionalVehiclesMsg = 'Would you like to refinance a vehicle loan that did not appear above?';
        }

        return (
            <div>
                <section className={classes.description}>
                    <div className={classes.icon}>
                        <div className={classes.check} />
                    </div>
                    <div className={classes.text}>
                        {!showVinReminder && (
                            <div>
                                <h3>Application Submitted</h3>
                                {isCU &&
                                    <p>Thanks for submitting your application with us. We will be in touch shortly!</p>
                                }
                                {isDealer &&
                                    <Fragment>
                                        <p>Thanks for submitting your application with us! While you are here, why not take the next step and upload documents that will be needed?</p>
                                        <Button
                                            width={90}
                                            tag="a"
                                            href="#"
                                            onClick={this.handleStipsClick}
                                            title="Upload Documents"
                                            role="button">
                                            Upload Documents
                                        </Button>
                                    </Fragment>
                                }
                                {contactPhone && (
                                    <p>
                                        If you need to speak to us you can call us at <a href={`tel:${contactPhone}`}>{contactPhone}</a>.
                                    </p>
                                )}
                            </div>
                        )}
                        {(showVinReminder && !submitted) && (
                            <div>
                                <h3>VIN Reminder</h3>
                                <p>
                                    Please submit your VIN as soon as possible. We cannot
                                    process your application without it.
                                </p>
                                <h4 className={classes.left}>Places to find your VIN:</h4>
                                <ul className={classes.left}>
                                    <li>Dashboard on the driver&#39;s side of the vehicle</li>
                                    <li>Driver&#39;s side door post</li>
                                    <li>Insurance Card</li>
                                </ul>
                                <Form className={classes.text && classes.left}>
                                    <Vin
                                        buyerName={buyerName}
                                        handleChange={this.onVinChange}
                                        includeExperian={true}
                                        includeNADA={true}
                                        vehicleInfo={vehicleInfo}
                                        showErrors={true} />
                                    {(vin && vinTrims.length > 0) && (
                                        <Trim
                                            contactPhone={contactPhone}
                                            handleChange={this.onVehicleChange}
                                            handleAccessoriesChange={this.onAccessoryChange}
                                            showErrors={true}
                                            vehicleInfo={vehicleInfo}
                                            trims={vinTrims} />
                                    )}
                                    <Button disabled={!canSubmitVin} onClick={this.handleSaveClick}>Submit VIN</Button>
                                </Form>
                            </div>
                        )}
                        {submitted && (
                            <div>
                                <h3>VIN Submitted</h3>
                                <p>
                                    Thank you for submitting your VIN!  We have started
                                    processing your deal and will contact you soon.
                                </p>
                            </div>
                        )}
                        <div className={classes.topMargin}>
                            {ltvPass && (
                                <Fragment>
                                    <h3>What&apos;s Next?</h3>
                                    <p>
                                        Want to speed up the refinancing process? We&apos;ll need a
                                        few documents to finalize your application. We can collect them
                                        later, or you can provide them now!
                                    </p>
                                    <Button onClick={this.handleStipsClick}>Provide Documents</Button>
                                </Fragment>
                            )}
                            {isCU && hasOtherLoans && (
                                <Fragment>
                                    <h3>Good News</h3>
                                    <p>Click on one of the following loans to refinance the associated vehicle.</p>
                                    {otherLoans.map((loan, i) => {
                                        const {
                                            _id: otherLoanId,
                                            choice = {},
                                            originationDate,
                                            originalBalance,
                                            payment,
                                            originalTerm,
                                            rate
                                        } = loan;
                                        const {
                                            betterRate,
                                            lifeTimeSavings,
                                            lowerPayment,
                                            payment: newPayment,
                                            rateReduction
                                        } = choice;

                                        if (!betterRate) {
                                            return;
                                        }

                                        const formattedOriginationDate = moment(originationDate).format('L');
                                        const formattedBalance = formatMoney(originalBalance);
                                        const formattedRate = formatPercent(rate, 'dynamic');
                                        const formattedRateReduction = formatPercent(rateReduction, 'dynamic');
                                        const formattedPayment = formatMoney(payment);
                                        const formattedNewPayment = formatMoney(newPayment);
                                        const formattedLifeTimeSavings = formatMoney(lifeTimeSavings);

                                        return (
                                            <div key={otherLoanId} className={classes.otherLoan}>
                                                <h3>Vehicle #{i+1}</h3>
                                                <p>
                                                    <b>Original Loan Amount:</b>
                                                    <br />{formattedBalance}<br />
                                                </p>
                                                <p>
                                                    <b>Origination Date:</b>
                                                    <br /> {formattedOriginationDate}
                                                </p>
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <b>Payment</b><br />
                                                                {formattedPayment}
                                                            </td>
                                                            <td>
                                                                <b>Rate</b><br />
                                                                {formattedRate}
                                                            </td>
                                                            <td>
                                                                <b>Org. Term</b><br />
                                                                {originalTerm} months
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <p><i>
                                                    We think we can save you
                                                    about <b>{formattedLifeTimeSavings}</b> on
                                                    your vehicle by reducing your rate
                                                    by <b>{formattedRateReduction}</b>.
                                                    {lowerPayment && (
                                                        <span>
                                                            This would change your monthly
                                                            payment to <b>{formattedNewPayment}</b>.
                                                        </span>
                                                    )}
                                                </i></p>
                                                <p>
                                                    <Button
                                                        disabled={addedAdditionalVehicle}
                                                        onClick={() => this.handleAdditionalVehicleClick({otherLoanId})}>
                                                        Add this Vehicle
                                                    </Button>
                                                </p>
                                            </div>
                                        );
                                    })}
                                </Fragment>
                            )}
                            {isCU &&
                                <>
                                    <p><b>{additionalVehiclesMsg}</b></p>
                                    <Button
                                        disabled={addedAdditionalVehicle}
                                        onClick={this.handleAdditionalVehicleClick}>
                                        Yes, Add Another Vehicle
                                    </Button>
                                </>
                            }
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {dealInfo = {}, vehicleInfo = {}, config = {}} = state;
    const {otherLoans = []} = dealInfo;
    const {contactPhone} = config;
    const {vehicleInfoType} = vehicleInfo;
    const buyerName = get(state, 'buyerInfo.buyerInfo.name');
    const ltvPass = get(state, 'navigation.currentStepData.ltvPass', false);
    const showVinReminder = !SessionService.isCCRMode() && vehicleInfoType === 'neither';
    const stips = get(state, 'stips.stipsData.app.stips', []);
    const dealType = get(state, 'creditor.type', 'creditUnion');

    return {
        buyerName,
        isCU: dealType === 'creditUnion',
        isDealer: dealType === 'dealer',
        otherLoans,
        showVinReminder: dealType === 'dealer' ? false : showVinReminder,
        contactPhone,
        ltvPass,
        offerId: getOfferId(),
        stips,
        vehicleInfo
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(Congrats));
